<template lang="pug">
    .heading-container(:class="[spacingTop, spacingBottom, textAlignment ]")
        component(v-if="heading", :is="headingTag", :class="classes.heading" v-html="heading")
        component(v-if="subHeading", :is="subHeadingTag", :class="classes.subHeading" v-html="subHeading")

</template>

<script>
// import _ from 'lodash'
import get from 'lodash.get';

export default {
    name: 'Heading',
    props: {
        section: {
            type: Object,
            required: true
        },
        headingTag: {
            type: String,
            default: 'h2'
        },
        headingClass: {
            type: String,
            default: 'title regular'
        },
        subHeadingTag: {
            type: String,
            default: 'h3'
        },
        subHeadingClass: {
            type: String,
            default: 'subtitle regular'
        }
    },
    computed: {
        heading() {
            let heading = get(this.section, 'contents.0.title');
            if (heading) {
                heading = heading.replace('®', '<sup>®</sup>');
            }
            return heading;
        },
        subHeading() {
            let subHeading = get(this.section, 'contents.0.sub_title');
            if (subHeading) {
                subHeading = subHeading.replace('®', '<sup>®</sup>');
            }
            return subHeading;
        },
        textAlignment() {
            let alignment = 'text-left';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'text_alignment');
                if (setting && setting.value !== undefined) alignment = setting.value;
            }

            return alignment;
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },

        classes() {
            let classes = {
                heading: this.headingClass,
                subHeading: this.subHeadingClass
            };

            const settings = get(this.section.contents[0], 'settings') || [];
            const titleSize = settings.find(setting => setting.key === 'title_size');
            const subTitleSize = settings.find(setting => setting.key === 'sub_title_size');

            if (titleSize && titleSize.value !== undefined) {
                switch (titleSize.value) {
                    case 'small':
                        classes.heading = 'title small';
                        break;

                    case 'big':
                        classes.heading = 'title big';
                        break;

                    case 'regular':
                    default:
                        classes.heading = 'title regular';
                }
            }

            if (subTitleSize && subTitleSize.value !== undefined) {
                switch (subTitleSize.value) {
                    case 'small':
                        classes.subHeading = 'subtitle small';
                        break;

                    case 'big':
                        classes.subHeading = 'subtitle big';
                        break;

                    case 'regular':
                    default:
                        classes.subHeading = 'subtitle regular';
                        break;
                }
            }
            return classes;
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"
.heading-container
    .title
        color: $color-primary
        &.big
            @apply font-semibold text-2xl
            @screen lg
                @apply text-3xl
        &.regular
            @apply font-semibold text-xl
            @screen lg
                @apply text-2xl
        &.small
            @apply font-semibold text-lg
            @screen lg
                @apply text-xl

    .subtitle
        &.big
            @apply text-lg
            @screen lg
                @apply text-xl
        &.regular
            @apply text-base
            @screen lg
                @apply text-lg font-bold
        &.small
            @apply text-sm
            @screen lg
                @apply text-base
</style>
